module.exports = __webpack_public_path__ + "static/media/CONSOLIDADO_ESTRATO.d54d73b5.pdf";